(ns common.schema.entities.account.options)

(def responsibility-options
  [{:key   :responsibility/option-1
    :label "I'm responsible for portfolio and/or LP reports"}
   {:key   :responsibility/option-2
    :label "I'm the primary deal flow manager in our team"}])

(def nylas-privacy-options
  [{:key   :privacy-status/public
    :label "Public"}
   {:key   :privacy-status/private
    :label "Private"}])

(def mfa-status-options
  [{:key   :mfa.status/secret-sent
    :label "Secret sent"} ;; Next time user logs in they must activate MFA
   {:key   :mfa.status/assigned
    :label "Assigned"}])              ;; MFA in use and enforced

(def nylas-status-options
  [{:key   :nylas.status/active
    :label "Active"}
   {:key   :nylas.status/error
    :label "Error"}
   {:key   :nylas.status/disconnected
    :label "Disconnected"}
   {:key   :nylas.status/error-dismissed
    :label "Error dismissed"}])

(def onboarding-team-role-options
  [{:key   :team-role/option-1
    :label
    "I make or propose investment decisions to an investment committee, BoD or similar. (e.g. Partner)"}
   {:key   :team-role/option-2
    :label "I work with investment decision makers in deal preparation (e.g. Analyst, Associate)"}
   {:key   :team-role/other
    :label "Other"}])
